module.exports = __webpack_public_path__ + "img/qr_code.27cdca62.jpg";